/* eslint-disable arrow-body-style */

export function addUserInfoPermission(userInfo) {
  return {
    type: 'ADD_USER_INFO_PERMISSION',
    userInfo,
  };
}

export function addCompanyId(idPessoaEmpresa) {
  return {
    type: 'ADD_COMPANY_ID',
    idPessoaEmpresa,
  };
}

export function addUserID(userID) {
  return {
    type: 'ADD_USER_ID',
    userID,
  };
}
